import React from "react";
import useReveal from "../hooks/useReveal";
import HeroVideo from "../components/HeroVideo";
import ManifestoTicker from "../components/ManifestoTicker";
import Logos from "../components/Logos";
import ServicesEditorial from "../components/ServicesEditorial";
import PhilosophySplit from "../components/PhilosophySplit";
import StatsLine from "../components/StatsLine";
import CaseStudies from "../components/CaseStudies";
import TestimonialsPremium from "../components/TestimonialsPremium";
import CtaPremium from "../components/CtaPremium";

export default function HomePage() {
  useReveal();
  return (
    <div className="page-enter">
      <HeroVideo />
      <ManifestoTicker />
      <Logos />
      <ServicesEditorial />
      <PhilosophySplit />
      <StatsLine />
      <CaseStudies />
      <TestimonialsPremium />
      <CtaPremium />
    </div>
  );
}
